import { render, staticRenderFns } from "./PayOnCollect.vue?vue&type=template&id=fe2f8fa8&"
import script from "./PayOnCollect.vue?vue&type=script&lang=js&"
export * from "./PayOnCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports